export default "__VITE_ASSET__RWkTNJdx__"